<template>
  <div :style="`${heightData}overflow: hidden`">
    <b-row>
      <b-col class="text-center">
        <h3 class="mt-2">
          {{ form.formTitle ? form.formTitle[selectedLanguage || "english"] : "No Title" }}
        </h3>
        <p>
          {{ form.formDescription ? form.formDescription[selectedLanguage || "english"] : "No Description" }}
        </p>
      </b-col>
    </b-row>
    <div
      id="scrollspy"
      class="preview-scrollable-wrapper p-3"
    >
      <div
        v-if="form.formSection.length"
        id="element"
        style="background-color: #f4f4f4"
      >
        <b-form v-if="!isLoading">
          <SectionContainer
            v-for="(sectionData, index) in form.formSection"
            :id="'section_' + index"
            :isDisabled="isDisabled"
            :isPreview="true"
            :selectedLanguage="selectedLanguage"
            :sectionData="sectionData"
            :inputType="sectionData.inputType"
            :key="index"
            :counter="index"
          />
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import SectionContainer from "../../containers/SectionUserContainer.vue";

export default {
  name: "EmployeeApprovalForm",
  components: {
    SectionContainer,
  },
  data () {
    return {};
  },

  mounted () { },

  beforeDestroy () { },

  beforeRouteLeave ( to, from, next ) { },

  computed: {},

  watch: {},
  created () { },
  methods: {},
  props: {
    form: Object,
    heightData: {
      type: String,
      required: false,
      default: 'height: calc(100vh - 285px);'
    },
    isLoading: Boolean,
    isDisabled: Number,
    selectedLanguage: String
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(calc(100vh - 367px));
  /* height:400px */
}
.selectPicket {
  width: 350px;
}
</style>

